import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

export const payersService = createCrudService("payers", [], router);